import humps from 'humps';

const removeEmptyProps = (obj = {}) => {
  const result = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] !== '') {
      result[key] = obj[key];
    }
    if (result[key] !== undefined && key === 'sortBy') {
      result[key] = humps.decamelize(result[key]);
    }

    if (key === 'numberOfApplicants') {
      if (obj[key] === 0) {
        result.jobApplicantsCountLteq = 0;
      } else if (obj[key] === 1) {
        result.jobApplicantsCountGteq = 1;
      } else if (obj[key] !== undefined && obj[key] !== '') {
        // Preserve unexpected values or handle them appropriately
        result.numberOfApplicants = obj[key];
      }
      // Only remove the original field when we've transformed 0 or 1
      if (obj[key] === 0 || obj[key] === 1) {
        delete result.numberOfApplicants;
      }
    }
    if (key === 'sourcingCampaignStatus') {
      // Handle array values - convert to snake_case for API
      // Empty string is a valid value meaning "not boosted"
      if (Array.isArray(obj[key])) {
        if (obj[key].length === 0) {
          // Empty array - don't include in result
          delete result[key];
        } else {
          // Preserve empty strings in the array as they represent "not boosted"
          result.sourcingCampaignStatus = obj[key];
        }
      } else if (obj[key] !== null && obj[key] !== undefined) {
        // Handle single value (shouldn't happen with multi-select, but handle for safety)
        result.sourcingCampaignStatus = Array.isArray(obj[key]) ? obj[key] : [obj[key]];
      }
    }
  });

  return result;
};

export default removeEmptyProps;
